import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from 'components/Button';

const ModalAside = ({
  trialId,
  modalData = {},
  accessor = {},
  prescreenButtonText = 'Prescreen to Connect',
  siteText = 'Site',
  addressText = 'Address',
  onSiteConnectClick = null,
  distanceUnit = 'miles',
  setModalOpen,
}) => {
  return (
    <Grid direction="column" spacing={2} container>
      <Grid item>
        <Typography variant="subtitle2" color="primary">
          {siteText}
        </Typography>
        <Typography variant="body2">{modalData[accessor.name]}</Typography>
      </Grid>
      <Grid item>
        <Typography variant="subtitle2" color="primary">
          {addressText}
        </Typography>
        <Typography variant="body2">{modalData[accessor.address]}</Typography>
      </Grid>
      <Grid item>
        <Button
          component="a"
          href={onSiteConnectClick ? '#' : modalData[accessor.link]}
          variant="outlined"
          color="primary"
          size="small"
          square
          onClick={
            onSiteConnectClick
              ? (e) => {
                  onSiteConnectClick(
                    { trialId, site: modalData, distanceUnit },
                    e,
                  );
                  setModalOpen(false);
                }
              : null
          }
        >
          {prescreenButtonText}
        </Button>
      </Grid>
    </Grid>
  );
};

export default ModalAside;
